function HomeAboutSection() {
  return (
    <section className="bg-cream-100 py-20 lg:py-28" id="om-oss">
      <div className="site-rail">
        <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr]">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-sand-600">
              <span className="h-px w-8 bg-sand-500" />
              Om OmsorgBygg
            </p>
            <h2 className="mt-5 font-serif text-[clamp(2.2rem,4.6vw,3.6rem)] font-bold leading-[1.04] text-forest-900 text-balance">
              En erfaren utleier med boliger over hele landet.
            </h2>
            <div className="mt-8 grid gap-6 sm:grid-cols-2">
              <p className="text-[1.08rem] leading-[1.75] text-forest-500">
                OmsorgBygg eier og forvalter boliger og omsorgsbygg flere steder i Norge. Vi legger vekt på god
                standard, forutsigbare leieforhold og tett oppfølging av leietakerne våre.
              </p>
              <p className="text-[1.08rem] leading-[1.75] text-forest-500">
                På denne siden finner du en oppdatert oversikt over hvilke eiendommer som er ledige, hvor de ligger og
                når de er tilgjengelige. Finner du noe som passer, kan du melde interesse direkte på den enkelte
                eiendommen.
              </p>
            </div>
            <div className="mt-9 flex flex-wrap gap-3">
              {['Forutsigbare leieforhold', 'God standard', 'Tett oppfølging'].map((tag) => (
                <span
                  className="rounded-full border border-forest-700/15 bg-white px-5 py-2.5 text-sm font-semibold text-forest-700 shadow-sm"
                  key={tag}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="hover-lift overflow-hidden rounded-[2rem] shadow-soft">
              <img
                alt="Boliger og omsorgsbygg"
                className="aspect-[4/3] w-full object-cover"
                loading="lazy"
                src="https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=1400&q=80"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden rounded-2xl bg-forest-700 px-7 py-5 shadow-lift sm:block">
              <p className="font-serif text-3xl font-bold text-cream-50">Hele Norge</p>
              <p className="mt-1 text-sm font-medium uppercase tracking-[0.16em] text-sand-200">Vår portefølje</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeAboutSection;